import React from 'react';
import type { SocialIcon as SocialIconData } from '../data/socialIcons';

/** Renders one brand social glyph, inheriting colour from currentColor. */
export function SocialIcon({
  icon,
  size = 20,
  className = ''
}: {
  icon: SocialIconData;
  size?: number;
  className?: string;
}) {
  return <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={1.5} strokeLinecap="round" strokeLinejoin="round" aria-hidden="true" className={className} dangerouslySetInnerHTML={{
    __html: icon.paths
  }} data-id="element-238" data-mp="3jia243c4rzk8" />;
}